import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateInternationalRescueCommitteeFonts: CreatomateFont[] = [
  {
    family: "Akzidenz-Grotesk Std Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdBol.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdBolIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Regular",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdReg.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Regular Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdLig.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Light Italic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdLigIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Medium",
    weight: 500,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdMed.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Medium Italic",
    weight: 500,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdMedIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Heavy",
    weight: 900,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdSup.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Heavy Italic",
    weight: 900,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdSupIta.otf"
  }
];

export const BuiltInInternationalRescueCommitteeFonts: BuiltInFontDefinition[] = [
  {
    family: "Akzidenz-Grotesk Std Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdBol.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdBolIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Regular Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdLig.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Light Italic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdLigIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Medium",
    weights: [500],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdMed.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Medium Italic",
    weights: [500],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdMedIta.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Regular",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdReg.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Heavy",
    weights: [900],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdSup.otf"
  },
  {
    family: "Akzidenz-Grotesk Std Heavy Italic",
    weights: [900],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/IRC/AkzidGroStdSupIta.otf"
  }
];
